<template>
  <page>
    <form data-vv-scope="forms">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>Details - {{this.polMaster.polNo + ' ' + this.polMaster.renCnt + ' ' + this.polMaster.endtCnt}}</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs6>
                <v-text-field v-model="forms.polStat" :label="labels.polStat" :error-messages="errors.collect('forms.polStat')" data-vv-name="forms.polStat" :data-vv-as="labels.polStat" v-validate="doValPolStat" @change="getPolStat($event)" :disabled="this.polMaster.polStat === 'CA'">
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="showPolStatHelpList = true" v-text="'mdi-magnify'" :disabled="this.polMaster.polStat === 'CA'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete :items="reciprocalBusList" v-model="forms.recip" :label="labels.recip" item-text="label" item-value="value" :error-messages="errors.collect('forms.recStat')" data-vv-name="forms.recStat" :data-vv-as="labels.recip" :disabled="this.polMaster.dri === true" clearable></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="forms.cedPolNo" :label="labels.cedPolNo" :error-messages="errors.collect('forms.cedPolNo')" data-vv-name="forms.cedPolNo" :data-vv-as="labels.cedPolNo" v-validate="'entry|max:20'" :disabled="this.polMaster.dri === true"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="forms.cedCesNo" :label="labels.cedCesNo" :error-messages="errors.collect('forms.cedCesNo')" data-vv-name="forms.cedCesNo" :data-vv-as="labels.cedCesNo" v-validate="'entry|max:40'" :disabled="this.polMaster.dri === true"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <cal-picker v-model="forms.ccaDate" :label="labels.ccaDate" :data-vv-as="labels.ccaDate" data-vv-name="forms.ccaDate" :error-messages="errors.collect('forms.ccaDate')" v-validate="valContrctCertDate" :disabled="this.polMaster.dri === true"></cal-picker>
              </v-flex>
              <v-flex xs6>
                <cal-picker v-model="forms.ccdDate" :label="labels.ccdDate" :data-vv-as="labels.ccdDate" data-vv-name="forms.ccdDate" :error-messages="errors.collect('forms.ccdDate')" v-validate="valContrctDocDate" :disabled="this.polMaster.dri === true"></cal-picker>
              </v-flex>
              <v-flex xs6>
                <cal-picker v-model="forms.retroDate" :label="labels.retroDate" :data-vv-as="labels.retroDate" data-vv-name="forms.retroDate" :error-messages="errors.collect('forms.retroDate')" v-validate="doValidateDate"></cal-picker>
              </v-flex>
              <v-flex xs6>
                <v-checkbox color="primary" :label="labels.resetIPC" v-model="forms.resetIPC" @change="doResetIPC" :disabled="(this.cPolMaster.ipcStat === undefined || this.cPolMaster.ipcStat ==='')"></v-checkbox>
              </v-flex>
              <v-flex xs6>
                <v-text-field v-model="forms.ipcStat" :label="labels.ipcStat" :error-messages="errors.collect('forms.ipcStat')" data-vv-name="forms.ipcStat" :data-vv-as="labels.ipcStat" v-validate="'entry|max:2'" :disabled="this.forms.resetIPC === false"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <cal-picker v-model="forms.ipcDate" :label="labels.ipcDate" :data-vv-as="labels.ipcDate" data-vv-name="forms.ipcDate" :error-messages="errors.collect('forms.ipcDate')" :disabled="this.forms.resetIPC === false"></cal-picker>
              </v-flex>
              <v-flex xs12>
                <v-btn color="error" dark @click.prevent="doExit">
                  {{actionLabel.exit}}
                  <v-icon dark right>mdi-exit-to-app</v-icon>
                </v-btn>
                <v-btn color="secondary" dark @click="doReset">
                  {{actionLabel.reset}}
                  <v-icon dark right>mdi-refresh</v-icon>
                </v-btn>
                <v-btn color="info" dark @click.prevent="doSave" :loading="submitting">
                  {{actionLabel.save}}
                  <v-icon dark right>mdi-content-copy</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs12>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex lg12 xs12 order-lg1 order-xs2>
                      <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType" :requestComCount ='false'></common-comments>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </form>
    <v-dialog v-model="showPolStatHelpList" width="1280px" >
      <policy-stat-help-list defFilter='polAmend' :boolRefresh="showPolStatHelpList" @close="showPolStatHelpList = false" @assign-pol-stat-info="assignPolStatInfor"></policy-stat-help-list>
    </v-dialog>
    <v-dialog v-model="showErrorDialog" width="800px" >
      <v-card>
        <v-card-title primary-title>
        <div>
            <div class="headline">System Information</div>
            <span class="grey--text">An error occurred when creating Amend Policy.</span>
        </div>
        </v-card-title>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Error Details:</v-subheader>
            <ul class="showErrorMsgs">
            <li v-for="(error, index) in messages" :key="index">
              {{error.message}}
            </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="promptDialog" width="20%"  persistent>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>
              Warning
            <v-spacer></v-spacer>
            <v-btn flat icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-text>
              <v-container fluid grid-list-sm>
                <v-layout row wrap>
                  <v-flex xs12>
                    {{warnMsg}}
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="processingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import PolicyStatHelpList from '@/components/core/common/dialog/PolicyStatHelpList'
import { expandURI } from '@/utils/ajax'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import subDays from 'date-fns/subDays'
import { parseISO } from 'date-fns'
import CommonComments from '@/components/core/accounting/CommonComments'

export default {
  data() {
    return {
      labels: {
        polStat: 'Policy Status',
        recip: 'Reciprocal Business',
        cedPolNo: 'Cedant Policy No',
        cedCesNo: 'Cedant Cession No',
        ccaDate: 'Contract Certainty Acceptance Date',
        ccdDate: 'Contract Certainty Documentation Date',
        retroDate: 'Retroactive Date',
        ipcStat: 'IPC Status',
        ipcDate: 'IPC Download Date',
        resetIPC: 'Reset IPC Status and Download Date'
      },
      actionLabel: {
        exit: 'Exit',
        reset: 'Reset',
        save: 'Save'
      },
      forms: {
        polStat: undefined,
        recip: undefined,
        cedPolNo: undefined,
        cedCesNo: undefined,
        ccaDate: undefined,
        ccdDate: undefined,
        retroDate: undefined,
        polNo: undefined,
        renCnt: undefined,
        endtCnt: undefined,
        ipcStat: undefined,
        ipcDate: undefined,
        resetIPC: false
      },
      resultForms: {
        polStat: '',
        recip: '',
        cedPolNo: '',
        cedCesNo: '',
        ccaDate: '',
        ccdDate: '',
        retroDate: '',
        polNo: '',
        renCnt: '',
        endtCnt: '',
        ipcStat: '',
        ipcDate: '',
        resetIPC: false
      },
      cPolMaster: {
        polStat: undefined,
        recip: undefined,
        cedPolNo: undefined,
        cedCesNo: undefined,
        ccaDate: undefined,
        ccdDate: undefined,
        retroDate: undefined,
        ipcStat: undefined,
        ipcDate: undefined
      },
      reciprocalBusList: [
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' },
        { label: 'Consortium', value: 'C' }
      ],
      showPolStatHelpList: false,
      submitting: false,
      isValPolStat: true,
      showErrorDialog: false,
      polStatPerRen: undefined,
      polStatPerNewRen: undefined,
      promptDialog: false,
      isExistComment: false,
      isChanged: false,
      warnMsg: '',
      processingFlag: false,
      verCnt: 0
    }
  },
  methods: {
    async doInit() {
      this.getLatestPolAmdt()
      await this.$store.dispatch('commonCommentsManagementInit')
      this.doReset()
    },
    doExit() {
      this.$router.push({ name: 'policyListing' })
    },
    doReset() {
      this.resetValidator()
      this.resetMessages()
      this.cPolMaster.polStat = this.polMaster.polStat !== null ? this.polMaster.polStat : undefined
      this.cPolMaster.recip = this.polMaster.recip !== null ? this.polMaster.recip : undefined
      this.cPolMaster.cedPolNo = this.polMaster.cedPolNo !== null ? this.polMaster.cedPolNo : undefined
      this.cPolMaster.cedCesNo = this.polMaster.cedCesNo !== null ? this.polMaster.cedCesNo : undefined
      this.cPolMaster.ccaDate = this.polMaster.ccaDate !== null ? parseISO(this.polMaster.ccaDate) : undefined
      this.cPolMaster.ccdDate = this.polMaster.ccdDate !== null ? parseISO(this.polMaster.ccdDate) : undefined
      this.cPolMaster.retroDate = this.polMaster.retroDate !== null ? parseISO(this.polMaster.retroDate) : undefined
      this.cPolMaster.ipcStat = this.polMaster.ipcStatus !== null ? this.polMaster.ipcStatus : undefined
      this.cPolMaster.ipcDate = this.polMaster.ipcDate !== null ? parseISO(this.polMaster.ipcDate) : undefined

      this.forms.polStat = this.cPolMaster.polStat
      this.forms.recip = this.cPolMaster.recip
      this.forms.cedPolNo = this.cPolMaster.cedPolNo
      this.forms.cedCesNo = this.cPolMaster.cedCesNo
      this.forms.ccaDate = this.cPolMaster.ccaDate
      this.forms.ccdDate = this.cPolMaster.ccdDate
      this.forms.retroDate = this.cPolMaster.retroDate
      this.forms.ipcStat = this.cPolMaster.ipcStat
      this.forms.ipcDate = this.cPolMaster.ipcDate
      this.forms.polNo = this.polMaster.polNo
      this.forms.renCnt = this.polMaster.renCnt
      this.forms.endtCnt = this.polMaster.endtCnt
    },
    doResetIPC() {
      this.forms.ipcStat = undefined
      this.forms.ipcDate = undefined
      this.forms.resetIPC = false
    },
    doSave() {
      this.getPolStat(this.forms.polStat).then(result => {
        if (result) {
          this.$validator.validateAll('forms').then(result2 => {
            if (result2) {
              if (this.forms.polStat === this.cPolMaster.polStat && this.forms.recip === this.cPolMaster.recip &&
                this.forms.cedCesNo === this.cPolMaster.cedCesNo && this.forms.cedPolNo === this.cPolMaster.cedPolNo &&
                this.forms.ccaDate === this.cPolMaster.ccaDate && this.forms.ccdDate === this.cPolMaster.ccdDate &&
                this.forms.retroDate === this.cPolMaster.retroDate && this.forms.ipcStat === this.cPolMaster.ipcStat &&
                this.forms.ipcDate === this.cPolMaster.ipcDate) {
                this.isChanged = false
                this.warnMsg = 'No detail has been changed'
                this.promptDialog = true
              } else {
                this.isChanged = true
                this.doProceed()
              }
            }
          })
        }
      })
    },
    doProceed() {
      this.checkComment().then(result => {
        if (result) {
          if (this.isExistComment === true) {
            this.doSubmit()
          }
        }
      })
    },
    async doSubmit() {
      this.processingFlag = true
      const apiURI = this.$store.state.underwriting.policyGeneralSettings.menu.savePolAmdt

      if (this.forms.polStat !== this.cPolMaster.polStat) {
        this.resultForms.polStat = this.forms.polStat
      }
      if (this.forms.recip !== this.cPolMaster.recip) {
        this.resultForms.recip = this.forms.recip
      }
      if (this.forms.cedCesNo !== this.cPolMaster.cedCesNo) {
        this.resultForms.cedCesNo = this.forms.cedCesNo
      }
      if (this.forms.cedPolNo !== this.cPolMaster.cedPolNo) {
        this.resultForms.cedPolNo = this.forms.cedPolNo
      }
      if (this.forms.ccaDate !== this.cPolMaster.ccaDate) {
        this.resultForms.ccaDate = this.forms.ccaDate
      }
      if (this.forms.ccdDate !== this.cPolMaster.ccdDate) {
        this.resultForms.ccdDate = this.forms.ccdDate
      }
      if (this.forms.retroDate !== this.cPolMaster.retroDate) {
        this.resultForms.retroDate = this.forms.retroDate
      }
      if (this.forms.ipcStat !== this.cPolMaster.ipcStat) {
        this.resultForms.ipcStat = this.forms.ipcStat
      }
      if (this.forms.ipcDate !== this.cPolMaster.ipcDate) {
        this.resultForms.ipcDate = this.forms.ipcDate
      }
      this.resultForms.resetIPC = this.forms.resetIPC
      this.resultForms.polNo = this.forms.polNo
      this.resultForms.renCnt = this.forms.renCnt
      this.resultForms.endtCnt = this.forms.endtCnt
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.resultForms)
          const { data } = result
          if (data) {
            this.processingFlag = false
            this.notify(data)
            this.$router.push({ name: 'policyListing' })
          }
        } catch (err) {
          const { data } = err.response
          this.processingFlag = false
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.processingFlag = false
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    assignPolStatInfor(data) {
      this.forms.polStat = data.polStat
      this.polStatPerRen = data.perRen
      this.polStatPerNewRen = data.perNewRen
      this.getPolStat(data.polStat)
    },
    async getPolStat(event) {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.valPolStat
      if (apiUrl) {
        try {
          const expand = {
            polStat: event
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            if (data.polStat !== null) {
              if (data.polStat.perAuto === false && data.polStat.perPol === true && data.polStat.polStat !== 'CA') {
                this.isValPolStat = true
                this.polStatPerRen = data.polStat.perRen
                this.polStatPerNewRen = data.polStat.perNewRen
              } else {
                this.isValPolStat = false
              }
            } else {
              this.isValPolStat = false
            }
          }
          return true
        } catch (err) {
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async checkComment() {
      const apiUrl = this.$store.state.commonComments.menu.isExistComment
      if (apiUrl) {
        try {
          const expand = {
            commentRefNo: this.polMaster.polNo + this.polMaster.renCnt + this.polMaster.endtCnt + this.verCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data === false) {
            this.promptDialog = true
            this.isExistComment = false
            this.warnMsg = 'Must enter a reason for amendment'
          } else {
            this.isExistComment = true
          }
          return true
        } catch (err) {
          this.loading = false
          return false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async getLatestPolAmdt() {
      const apiUrl = this.$store.state.underwriting.policyGeneralSettings.menu.getLatestPolAmdt
      if (apiUrl) {
        try {
          const expand = {
            polNo: this.polMaster.polNo,
            renCnt: this.polMaster.renCnt,
            endtCnt: this.polMaster.endtCnt
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data) {
            this.verCnt = data.verCnt + 1
          }
        } catch (err) {

        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    closeDialog() {
      this.promptDialog = false
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    },
    doValPolStat() {
      if (this.forms.polStat !== '') {
        return 'entry|max:2|valPolStat:' + this.isValPolStat + '|valPolStatNew:' + this.polMaster.tranType + ',' + this.polStatPerNewRen +
        '|valPolStatRenewal:' + this.polMaster.tranType + ',' + this.polStatPerNewRen + ',' + this.polStatPerRen
      } else {
        return ''
      }
    },
    doValidateDate() {
      return 'entry|valDate:' + this.polMaster.expDate
    },
    displayErrorDialog() {
      return this.messages
    },
    valContrctCertDate() {
      var date
      var dateName
      if (this.forms.ccaDate !== null && this.forms.ccaDate !== undefined) {
        if (this.polMaster.comDate != null && this.polMaster.comDate !== undefined) {
          date = this.polMaster.comDate
          dateName = 'Commencement Date'
        } else if (this.polMaster.tranDate != null && this.polMaster.tranDate !== undefined) {
          date = this.polMaster.tranDate
          dateName = 'Transaction Date'
        }
        var diffInTime = this.forms.ccaDate - parseISO(date)
        var diffInDay = diffInTime / (1000 * 3600 * 24) + 1
        return 'entry|valCcaDate:' + diffInDay + ',' + dateName
      }
      return ''
    },
    valContrctDocDate() {
      var date
      var dateName
      if (this.forms.ccdDate !== null && this.forms.ccdDate !== undefined) {
        if (this.polMaster.comDate != null && this.polMaster.comDate !== undefined) {
          date = this.polMaster.comDate
          dateName = 'Commencement Date'
        } else if (this.polMaster.tranDate != null && this.polMaster.tranDate !== undefined) {
          date = this.polMaster.tranDate
          dateName = 'Transaction Date'
        }
        var diffInTime = this.forms.ccdDate - parseISO(date)
        var diffInDay = diffInTime / (1000 * 3600 * 24) + 1
        return 'entry|valCcdDate:' + diffInDay + ',' + dateName
      }
      return ''
    },
    commentRefNo() {
      return this.polMaster.polNo + this.polMaster.renCnt + this.polMaster.endtCnt + this.verCnt
    },
    commentTranType() {
      return this.polMaster.tranType
    }
  },
  created() {
    this.$validator.extend('valPolStat', {
      getMessage(field, args) {
        return 'Invalid Policy Status'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isPolStatExist = args[0]
        if (isPolStatExist === 'true') {
          return true
        } else {
          return false
        }
      }
    })
    this.$validator.extend('valPolStatNew', {
      getMessage(field, args) {
        return 'Not a valid Policy Status for New Policy'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranType = args[0]
        var polStatPerNewRen = args[1]
        if (tranType === 'N' && polStatPerNewRen === 'false') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valPolStatRenewal', {
      getMessage(field, args) {
        return 'Not a valid Policy Status for Renewed Policy'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranType = args[0]
        var polStatPerNewRen = args[1]
        var polStatPerRen = args[2]
        if (tranType === 'R' && polStatPerNewRen === 'false' && polStatPerRen === 'false') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valDate', {
      getMessage(field, args) {
        return 'Cannot be later than Expiry date'
      },
      validate(value, args) {
        let expDate = args[0]
        expDate = subDays(removeTime(expDate), 1)
        if (value) {
          return !isAfter(removeTime(value), removeTime(expDate))
        } else return true
      }
    })
    this.$validator.extend('valCcaDate', {
      getMessage(field, args) {
        var dateName = args[1]
        return 'Contract Certainty Acceptance Date is 100 days earlier or later than ' + dateName + ' (10435)'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var totDays = args[0]
        if (totDays > 100) {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valCcdDate', {
      getMessage(field, args) {
        var dateName = args[1]
        return 'Contract Certainty Documentation Date is 100 days earlier or later than ' + dateName + ' (10435)'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var totDays = args[0]
        if (totDays > 100) {
          return false
        } else {
          return true
        }
      }
    })
  },
  watch: {
    'displayErrorDialog': {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ],
  components: {
    PolicyStatHelpList,
    CommonComments
  }
}

</script>
